import firebaseApp from "services/firebase";

/**
 * True when the page is being served from localhost (or 127.0.0.1).
 * Use to gate dev-only UI like debug transcripts that should never reach prod.
 */
export const isLocalhost = () =>
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

/**
 * True when running in a development/sandbox context.
 * Used to gate dev-only features (e.g. test auth, preview routes, MFA dev hints in enrollment).
 */
export const isDevEnvironment = () => {
  const projectId = firebaseApp.options.projectId;
  const isDevelopmentBuild = process.env.NODE_ENV === "development";

  const sandboxProjectIds = [
    "hlthdsk-sandbox-2cc23",
    "hlthdsk-experimental",
    "caremap2020",
  ];
  const isSandboxProject = sandboxProjectIds.includes(projectId);

  return isDevelopmentBuild || isLocalhost() || isSandboxProject;
};

/**
 * Set to `true` to require MFA enrollment (onboarding, Settings, dashboard gate)
 * even in dev/sandbox — use when debugging MFA. Sign-in MFA challenge is unchanged.
 */
export const FORCE_MFA_ENROLLMENT_IN_DEV = false;

/**
 * When true, MFA enrollment UI and required-enrollment routing are skipped (fast iteration).
 * Also skipped when REACT_APP_INVITE_ONLY is true (beta/demo mode — no PHI, no MFA friction).
 * False when not in dev, or when {@link FORCE_MFA_ENROLLMENT_IN_DEV} is true.
 */
export const shouldSkipMfaEnrollmentUi = () =>
  process.env.REACT_APP_INVITE_ONLY === "true" ||
  (isDevEnvironment() && !FORCE_MFA_ENROLLMENT_IN_DEV);
